// HOME
const HOME = 'Home';
const MY_DETAILS_POLICY_SELECTION = 'policy-selection';

// ERROR PAGES
const ERROR_OTHER = 'other';
const ERROR_UNAUTHORISED_ACCESS = 'unauthorised-access';
const ERROR_404_PAGE_NOT_FOUND = 'page-not-found';

// MY CLAIMS
const BENEFIT_QUOTE_GET_A_BENEFIT = 'get-a-benefit-quote';
const BENEFIT_QUOTE_QUOTES = 'benefit-quotes';
const BENEFIT_QUOTE_RESULT = 'benefit-quote-result';
const CLAIMS = 'claims';
const CLAIMS_MAKE_A_CLAIM = 'make-a-claim';
const CLAIMS_RESULT = 'new-claim-submission';
const CLAIMS_RESULT_KEEP_PRIVATE = 'new-claim-submission-private';
const LIMITS_USAGE = 'limits-and-usage';
const SNAP_AND_SEND = 'snap-and-send';
const SNAP_AND_SEND_RESULT = 'snap-and-send-result';

// MY COVER
const MY_COVER_REBATE_NOMINATION = 'rebate-nomination';
const MY_COVER_UPDATE_REBATE_TIER = 'update-rebate-tier';
const MY_COVER_REBATE_PREMIUM_IMPACT = 'rebate-premium-impact';
const MY_COVER_TAX_STATEMENTS = 'tax-statements';
const MY_COVER_PAYMENTS = 'payments';
const MY_COVER_PAYMENTS_SUCCESSFUL = 'payments-successful';
const MY_COVER_PREMIUM_CALCULATOR = 'premium-calculator';
const MY_COVER_MAKE_A_PAYMENT = 'make-a-payment';
const MY_COVER_MY_DOCUMENTS = 'my-documents';
const WAITING_PERIODS = 'waiting-periods';
const CHANGE_EXCESS = 'change-my-excess';
const CHANGE_EXCESS_PREMIUM_IMPACT = 'change-excess-premium-impact';

// MY COVER - CHANGE COVER
const CHANGE_MY_COVER = 'change-my-cover';
const CHANGE_MY_PRODUCT = 'change-my-product';
const KEEP_MY_COVER = 'keep-my-cover';
const PRODUCT_SELECTION = 'product-selection';
const CAPTURE_ADDITIONAL_INFORMATION = 'capture-additional-information';
const CHANGE_COVER_CONFIRMATION = 'change-cover-confirmation';
const ADD_REMOVE_PERSON = 'add-remove-person';

// MY DETAILS PAGES
const MY_DETAILS_MEMBER_SELECTION = 'member-selection';
const MY_DETAILS_VIEW_UPDATE_DETAILS = 'member-details';
const GENERATE_MEMBER_CARD_REQUEST = 'request-a-member-card';
const GENERATE_MEMBER_CARD_REQUEST_SUCCESS = 'request-success';
const NO_IMPACT_UPDATE_DETAILS = 'update-details-no-impact';
const PREMIUM_IMPACT_UPDATE_DETAILS = 'update-details-premium-impact';
const PAYMENT_SELECTION = 'payment-selection';
const PAYMENT_DETAILS = 'payment-details';
const PREMIUM_IMPACT_PAYMENT_DETAILS = 'premium-impact';

// SUPPORT
const CONTACT_US = 'contact-us';
const CONTACT_US_CONFIRMATION = 'contact-us-confirmation';

// NON NAV PAGES
const SEARCH_RESULT_FOUND = 'search';
const SEARCH_RESULT_NOT_FOUND = 'searchEmpty';
const LEGAL = 'legal';

// VIEW MEMBERSHIP CARDS PAGE
const VIEW_MEMBER_CARD_HOME = 'home';
const VIEW_MEMBER_CARD_UPDATE_SUCCESS = 'updated';

// REBATE CRM
const REBATE_OVERVIEW = 'home';
const REBATE_ADD_REBATE = 'add-rebate';
const REBATE_ADD_REBATE_SUCCESS = 'add-rebate-success';
const REBATE_UPDATE_REBATE = 'update-rebate';
const REBATE_UPDATE_REBATE_SUCCESS = 'update-rebate-success';
const REBATE_CHANGE_APPLICANT = 'change-rebate-applicant';
const REBATE_CHANGE_APPLICANT_SUCCESS = 'change-rebate-applicant-success';
const REBATE_UPDATE_MEDICARE = 'update-medicare';
const REBATE_UPDATE_MEDICARE_SUCCESS = 'update-medicare-success';
const REBATE_WITHDRAW = 'withdraw-rebate';

// REBATES MEMBER PORTAL
const REBATES_MEMBER_PORTAL = {
  REBATE_OVERVIEW: 'RebateOverview',
  REBATE_TIER_HISTORY: 'RebateTierHistory',
  ADD_REBATE: 'AddRebate',
  UPDATE_REBATE: 'UpdateRebate',
  WITHDRAW_REBATE: 'WithdrawRebate',
  REBATE_UPDATE_SUCCESS: 'RebateUpdateSuccess',
};

// SWITCH POLICY HOLDER CRM
const SWITCH_POLICY_HOLDER_HOME = 'home';
const POLICY_HOLDER_SWITCH_SUCCESS = 'policy-holder-switch-success';

// PREMIUM IMPACT
const PREMIUM_IMPACT_HOME = 'premium-impact-home';

// ADD REMOVE PERSON CRM
const ADD_REMOVE_PERSON_SUCCESS = 'add-remove-person-success';
// TODO: Add other CRM app pages

export {
  BENEFIT_QUOTE_GET_A_BENEFIT,
  BENEFIT_QUOTE_QUOTES,
  BENEFIT_QUOTE_RESULT,
  CLAIMS_MAKE_A_CLAIM,
  CLAIMS_RESULT,
  CLAIMS_RESULT_KEEP_PRIVATE,
  CLAIMS,
  LIMITS_USAGE,
  CONTACT_US_CONFIRMATION,
  CONTACT_US,
  ERROR_404_PAGE_NOT_FOUND,
  ERROR_OTHER,
  ERROR_UNAUTHORISED_ACCESS,
  GENERATE_MEMBER_CARD_REQUEST_SUCCESS,
  GENERATE_MEMBER_CARD_REQUEST,
  HOME,
  LEGAL,
  MY_COVER_MAKE_A_PAYMENT,
  MY_COVER_PAYMENTS_SUCCESSFUL,
  MY_COVER_PAYMENTS,
  MY_COVER_PREMIUM_CALCULATOR,
  MY_COVER_REBATE_NOMINATION,
  MY_COVER_REBATE_PREMIUM_IMPACT,
  MY_COVER_UPDATE_REBATE_TIER,
  MY_COVER_TAX_STATEMENTS,
  MY_COVER_MY_DOCUMENTS,
  MY_DETAILS_MEMBER_SELECTION,
  MY_DETAILS_POLICY_SELECTION,
  MY_DETAILS_VIEW_UPDATE_DETAILS,
  NO_IMPACT_UPDATE_DETAILS,
  PAYMENT_SELECTION,
  PREMIUM_IMPACT_PAYMENT_DETAILS,
  PAYMENT_DETAILS,
  PREMIUM_IMPACT_UPDATE_DETAILS,
  REBATE_OVERVIEW,
  REBATE_ADD_REBATE,
  REBATE_ADD_REBATE_SUCCESS,
  REBATE_UPDATE_REBATE,
  REBATE_UPDATE_REBATE_SUCCESS,
  REBATE_CHANGE_APPLICANT,
  REBATE_CHANGE_APPLICANT_SUCCESS,
  REBATE_UPDATE_MEDICARE,
  REBATE_UPDATE_MEDICARE_SUCCESS,
  REBATE_WITHDRAW,
  SEARCH_RESULT_FOUND,
  SEARCH_RESULT_NOT_FOUND,
  SNAP_AND_SEND,
  SNAP_AND_SEND_RESULT,
  VIEW_MEMBER_CARD_HOME,
  VIEW_MEMBER_CARD_UPDATE_SUCCESS,
  KEEP_MY_COVER,
  PRODUCT_SELECTION,
  CAPTURE_ADDITIONAL_INFORMATION,
  CHANGE_COVER_CONFIRMATION,
  CHANGE_MY_COVER,
  CHANGE_MY_PRODUCT,
  ADD_REMOVE_PERSON,
  SWITCH_POLICY_HOLDER_HOME,
  POLICY_HOLDER_SWITCH_SUCCESS,
  PREMIUM_IMPACT_HOME,
  ADD_REMOVE_PERSON_SUCCESS,
  WAITING_PERIODS,
  CHANGE_EXCESS,
  CHANGE_EXCESS_PREMIUM_IMPACT,
  REBATES_MEMBER_PORTAL,
};
